"use strict";
import { useCallback, useMemo } from "react";
import { useMismatchContext } from "features/smartWallet/mismatch/MismatchContext";
import {
  getIsMismatchAccountQueryOptions
} from "features/smartWallet/mismatch/queryOptions";
export function useMakeAccountMismatchQueryOptions(ctx) {
  const { isTestnetModeEnabled, defaultChainId } = useMismatchContext();
  const getQueryOptions = useMemo(
    () => getIsMismatchAccountQueryOptions({ hasMismatch: ctx.hasMismatch, isMainnet: !isTestnetModeEnabled }),
    [ctx.hasMismatch, isTestnetModeEnabled]
  );
  return useCallback(
    (chainId) => getQueryOptions({
      address: ctx.account.address,
      chainId: chainId ?? ctx.account.chainId ?? defaultChainId
    }),
    [ctx.account.address, ctx.account.chainId, defaultChainId, getQueryOptions]
  );
}
